import { useFetch } from '../../hooks';
import { useAuthProvider } from '../Auth';

export const useToken = () => {
  const authProvider = useAuthProvider();
  const {
    loading: isLoading,
    data: user,
    refresh,
  } = useFetch(authProvider.check!, [], {
    onSuccess: data => {
      !data && authProvider.startLogin?.();
    },
    onError: () => {
      authProvider.startLogin?.();
    },
  });

  return {
    ...authProvider,
    check: refresh,
    isLoading: isLoading || authProvider.isLoading,
    user,
  };
};
